export default __webpack_public_path__ + "static/21-39a75551f9e7bb8caca1cef48a008cb2.jpg";